import { Component, OnInit, ViewChild, Input } from '@angular/core'; 
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { StoreLocationService } from '../../shared/services/storelocation.service';
import { StoreLocation } from '../../shared/models/storeLocation';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LocationAddFormComponent } from '../../shared/components/modals/location-add-modal/location-add.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { LocationEditFormComponent } from '../../shared/components/modals/location-edit-modal/location-edit.component';
 
@Component({
  selector: 'app-locations', 
  templateUrl: './locations.component.html'
})

export class LocationsComponent implements OnInit {  
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<StoreLocation>();
  displayedColumns: string[] = ['actions','name', 'storeId', 'address', 'phone', 'email', 'url'];
  addForm: LocationAddFormComponent;
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private storeLocationService: StoreLocationService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService
  ) { }
   
  private _id; // private property _item

  // use getter setter to define the property
  get id(): any {
    return this._id;
  }

  @Input()
  set id(val: any) { 
    this._id = val; 
  } 

  // call get locations on load 
  ngOnInit() {
    this.getRecords(this.id);
  }

  // get locations
  getRecords(id: number): void {
    if (id > 0) {  
      this.storeLocationService.getAll(id).subscribe(result => { 
          this.dataSource.data = result;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 

      }, error => console.error(error));
    }
  }

  // open add form for location
  openAddModal() {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(LocationAddFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Add a Store Location';
    modalRef.componentInstance.brandId = this.id;

    // modal result
    modalRef.result.then((result) => {
      if (result) {
        this.getRecords(this.id);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    ); 
  } 

  // delete location
  deleteLocation(id: number) {

    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {  
          if (confirmed) {
            this.storeLocationService.delete(id).subscribe(() => {
              this.showNotification('The store location has been deleted successfully!', 'Okay!');
              this.getRecords(this.id);
            });
          }
        }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      ); 
  }

  // edit location
  editLocation(location: StoreLocation) {

    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(LocationEditFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Edit Store Location';
    modalRef.componentInstance.location = location;

    // modal result
    modalRef.result.then((result) => { 
      if (result) { 
        this.getRecords(this.id);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );  
  }
    
  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
   
  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
   
}

